
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FAQView } from '../components/FAQView';

const FAQPage: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className="py-8">
            {/* We pass an onBack handler to take the user to the consultation app */}
            <FAQView onBack={() => navigate('/app')} />
        </div>
    );
};

export default FAQPage;
